import React from "react";

const BlobDefinitions = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <g id="faq-blob-1">
        <path d="M -20,-30 C -60,-30 -70,20 -40,50 C -10,70 50,60 70,30 C 85,5 50,-10 30,-5 C 10,0 0,-30 -20,-30 Z" />
        <path
          d="M 35,-45 C 30,-65 60,-65 65,-45 C 70,-25 40,-25 35,-45 Z"
          transform="translate(-10, 15)"
        />
      </g>
      <g id="faq-blob-2">
        <path d="M -25,-25 C -65,-25 -70,25 -35,55 C -5,75 40,55 60,25 C 75,-5 45,-5 25,0 C 5,5 -5,-25 -25,-25 Z" />
        <path
          d="M 30,-50 C 25,-65 50,-70 55,-55 C 60,-40 35,-35 30,-50 Z"
          transform="translate(-10, 15)"
        />
      </g>
      <g id="faq-blob-3">
        <path d="M -15,-35 C -55,-40 -80,10 -50,40 C -20,70 60,70 80,40 C 95,10 50,-15 30,-5 C 10,5 5,-30 -15,-35 Z" />
        <path
          d="M 25,-40 C 20,-60 50,-65 55,-45 C 60,-25 30,-20 25,-40 Z"
          transform="translate(-10, 15)"
        />
      </g>
    </defs>
  </svg>
);

export default BlobDefinitions;
